import { DIGITAL, IKEA_FAMILY_ONLY } from "../../enums";
import { CSSEvent } from "../../types/model";
import { Colors } from "../Card/Badges";

const getBadges = (event: CSSEvent) => {
  const badges: [string, Colors][] = [];
  const isDigitalEvent = event.location.type === DIGITAL;

  if (event.loyaltyEvent === IKEA_FAMILY_ONLY) {
    badges.push([
      "event.ikeaFamilyOnly",
      {
        background: "--colour-cmsg-ikea-family",
        text: "--colour-neutral-white",
      },
    ]);
  }

  if (isDigitalEvent) {
    badges.push([
      "event.digitalEvent",
      {
        background: "--colour-brand-yellow",
        text: "--colour-text-dark",
      },
    ]);
  }

  return badges;
};

export default getBadges;
